<template>
    <div id="app" >
        <router-view></router-view>
    </div>
</template>
<script>
    export default {
        name: "App",
        data() {
            return {

            }
        },
        mounted() {
        }
    }
</script>
<style lang="less">
    body{
      padding: 0;
      margin: 0;
        //官网的时候把这一行注掉TODO
        /*background-color: #fafafa;*/
    }
   #app{
     width: 100%;
     margin: 0;
     padding: 0;
   }

</style>
